import { render, staticRenderFns } from "./AdminSurveyResults.vue?vue&type=template&id=e475693c&scoped=true"
import script from "./AdminSurveyResults.vue?vue&type=script&lang=js"
export * from "./AdminSurveyResults.vue?vue&type=script&lang=js"
import style0 from "./AdminSurveyResults.vue?vue&type=style&index=0&id=e475693c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e475693c",
  null
  
)

export default component.exports